export default "__VITE_ASSET__4a8169bf__"